export default "__VITE_PUBLIC_ASSET__6e0c69f0__"